<template>
    <div class="switcher">
        <div :class="['switcher_variant', { switcher_variant_active: !isActive }]">
            Monthly
        </div>
        <button
            :class="['switcher_toggle', { switcher_toggle_active: isActive }]"
            @click="handleToggle"
        />
        <div :class="['switcher_variant', { switcher_variant_active: isActive }]">
            Annually
        </div>
    </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core';

const props = withDefaults(defineProps<{ value?: boolean; }>(), { value: false });
const emit = defineEmits<{ (e: 'input', value: boolean): void }>();

const isActive = useVModel(props, 'value', emit, { eventName: 'input' });

function handleToggle() {
    isActive.value = !isActive.value;
}
</script>

<style lang="scss" scoped>
.switcher {
  display: flex;
  align-items: center;
  justify-content: center;

  &_variant {
    font-family: "ITC Avant Garde Gothic Std",serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 175%;
    color: #878c95;
    transition: color 0.3s;
    @media screen and (max-width: 1100px) {
      font-size: 12px;
    }
    @media screen and (max-width: 860px) {
      font-size: 14px;
    }
    &_active {
      color: #202020;
    }
  }
  &_toggle {
    margin: 0 16px;
    display: block;
    width: 80px;
    height: 48px;
    border-radius: 24px;
    position: relative;
    overflow: hidden;
    background-color: transparent;
    transition: all 0.3s;
    cursor: pointer;
    border: 1px solid #c4cad3;

    @media screen and (max-width: 1540px) {
      width: 64px;
      height: 40px;
      margin: 0 6px;
    }
    @media screen and (max-width: 1100px) {
      width: 52px;
      height: 32px;
    }
    &:before {
      content: "";
      position: absolute;
      width: 32px;
      height: 32px;
      top: 8px;
      left: 8px;
      background-color: #40acff;
      border-radius: 50%;
      transition: all 0.3s;
      @media screen and (max-width: 1540px) {
        top: 3px;
        left: 5px;
      }

      @media screen and (max-width: 1100px) {
        width: 26px;
        height: 26px;
        top: 2px;
        left: 2px;
      }
    }

    &_active {
      background-color: #40acff;
      border: 1px solid #40acff;
      &:before {
        left: 40px;
        background-color: #ffffff;
        @media screen and (max-width: 1540px) {
          left: 27px;
        }
        @media screen and (max-width: 1100px) {
          left: 23px;
        }
      }
    }
  }
}
</style>
